import React from 'react';
import cn from 'classnames';

export type ISvgIconProps = {
  className?: string;
  src: string;
  useDefaultSvgIconClassName?: boolean;
  width?: number;
  height?: number;
};

export const SvgIcon = (props: ISvgIconProps) => {
  const { src, className, useDefaultSvgIconClassName = true, width, height } = props;
  const defaultClassName = 'svg-icon';
  const iconClassName = cn(useDefaultSvgIconClassName && defaultClassName, className);

  return (
    <svg className={iconClassName} viewBox="0 0 20 20" width={width} height={height}>
      <use xlinkHref={src} className={className} />
    </svg>
  );
};
